import $ from 'jquery';
import Plyr from 'plyr';


function video() {
  $( '.video-block .video' ).each( function () {
    const videoElement = $( this ).get( 0 )
    let poster = $( this ).data( 'poster' );
    let autoplay = $(this).parent().hasClass('video--autoplay');
    let muted = autoplay?true:false;
    let controls = autoplay?[ 'play-large' ]:['play-large', 'play', 'progress', 'current-time', 'mute', 'volume'];
    if ( $( this ).hasClass( 'video--oembed' ) ) {
      const player = new Plyr( videoElement, {
        controls: controls,
        autoplay: autoplay,
        muted : muted,
        volume: muted?0:50,
        vimeo: { autoplay: autoplay },
        youtube: { autoplay: autoplay },
        fullscreen: { enabled: false }
      } )

      // Customize the Plyr controls
      player.on( 'ready', () => {
        

        $( '.video' ).on( 'click touchstart', function ( event ) {
          event.preventDefault()
          event.stopPropagation()
          if ( player.paused ) {
            player.play()
          } else {
            player.pause()
          }
        } )


      } )

      if ( poster ) player.poster = poster;
      if(autoplay){
        player.muted = true;
        player.volume = 0;
      }
      return player
    } else {
      let player = new Plyr( $( this ).get( 0 ), {
        controls: controls,
        autoplay: autoplay,
        muted : muted,
        volume: muted?0:50,
        vimeo: { autoplay: autoplay },
        youtube: { autoplay: autoplay },
        fullscreen: { enabled: false }
      } );
      if ( poster ) player.poster = poster;
      if(autoplay){
        player.muted = true;
        player.volume = 0;
        player.play();
      }
      return player;
    }
  } )
}



export { video };
